import request from '@/utils/request'


// 查询工种认证列表
export function listAuthentication(query) {
  return request({
    url: '/profession/profession-authentication/list',
    method: 'get',
    params: query
  })
}

// 查询工种认证分页
export function pageAuthentication(query) {
  return request({
    url: '/profession/profession-authentication/page',
    method: 'get',
    params: query
  })
}

// 查询工种认证详细
export function getAuthentication(data) {
  return request({
    url: '/profession/profession-authentication/detail',
    method: 'get',
    params: data
  })
}

// 新增工种认证
export function addAuthentication(data) {
  return request({
    url: '/profession/profession-authentication/add',
    method: 'post',
    data: data
  })
}

// 修改工种认证
export function updateAuthentication(data) {
  return request({
    url: '/profession/profession-authentication/edit',
    method: 'post',
    data: data
  })
}

// 删除工种认证
export function delAuthentication(data) {
  return request({
    url: '/profession/profession-authentication/delete',
    method: 'post',
    data: data
  })
}
